const exchangeAmountPredicator = (status?: string) => {
  if (status === '0' || status === '4' || status === '5') {
    return true;
  } else {
    return false;
  }
};

export { exchangeAmountPredicator };
